<div>
  <app-map height="900px" width="100%" id="map_poi">
    <app-map-marker-vehicle [vehicle]="v" *ngFor="let v of items"
      [showLabel]="true"
          ></app-map-marker-vehicle>
  </app-map>
</div>
